module.exports = __webpack_public_path__ + "static/media/up-chevron.fc2195aa.svg";